import type { PublicProductDetail } from '@repo/api-contracts';

/** 폼에 보일 상품 사진 — 고른 색상의 미리보기 그림, 없으면 대표 사진(images 1번), 그것도 없으면 null. */
export const plainQuoteProductImageUrl = (
  product: Pick<PublicProductDetail, 'images' | 'colorOptions'> | undefined,
  colorOptionId: string | null,
): string | null => {
  if (product === undefined) return null;
  const color = product.colorOptions.find((option) => option.id === colorOptionId);
  return color?.previewImage?.url ?? product.images[0]?.url ?? null;
};
